import HealthSection from './HealthSection'

export default HealthSection
